export const ProjectState = {
  idle: "idle",
  finished: "finished",
  processing: "processing",
  failed: "failed",
};
